import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import { playerReducer } from "../../../storage/reducers";
import FragmentSummary from "./fragment-summary";
import PatResultType from "../enums/pat-result-type";

export default class PuntBlocked extends Fragment {
    constructor(blockedBy) {
        super();

        this.code = "BLOCK";
        this.patCode = PatResultType.BLOCKED.code;
        this.blockedBy = blockedBy;

        this.requiredData = [
            {
                name: "blockedBy",
                type: FragmentDataType.Player,
                appliesToOpponent: () => true,
                displayName: "Blocked By",
                title: (team) => `Blocked By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player from ${team.teamName} or enter the roster number`,
                isEditable: true
            }
        ];
    }

    getPlayers() {
        return [this.blockedBy];
    }

    summarize(summaryContext, stringifier) {
        const message = `Blocked by ${stringifier.firstInitial(
            this.blockedBy
        )}`;
        return new FragmentSummary(message);
    }

    toJSON() {
        return {
            ...super.toJSON(),
            blockedBy: playerReducer(this.blockedBy)
        };
    }
}
